module.exports = __webpack_public_path__ + "img-a04b6a41f26906e5c8732586d2d1261b.png";


//////////////////
// WEBPACK FOOTER
// ./example/app/common/commonheader/images/fancyui.png
// module id = 84
// module chunks = 40